import React from 'react';
import { Mail, Phone, MapPin, MessageSquare, Clock } from 'lucide-react';

const ContactPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h1 className="text-4xl font-extrabold text-gray-900 mb-4">Contact PlanStack</h1>
          <p className="text-xl text-gray-600">
            Have questions about our directory, partnership opportunities, or need help with your listing? We're here to help.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12">
          {/* Contact Methods */}
          <div className="lg:col-span-1 space-y-8">
             <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-200">
                <div className="space-y-8">
                   <div className="flex items-start">
                      <div className="bg-brand-100 p-3 rounded-lg text-brand-600 mr-4">
                        <Mail size={24} />
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900">Email Us</h4>
                        <p className="text-sm text-gray-500 mb-1">For general enquiries & support</p>
                        <a href="mailto:hello@planstack.com.au" className="text-brand-600 font-bold hover:underline">hello@planstack.com.au</a>
                      </div>
                   </div>

                   <div className="flex items-start">
                      <div className="bg-brand-100 p-3 rounded-lg text-brand-600 mr-4">
                        <Phone size={24} />
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900">Call Us</h4>
                        <p className="text-sm text-gray-500 mb-1">Mon-Fri, 9am - 5pm AEST</p>
                        <a href="tel:1300000000" className="text-brand-600 font-bold hover:underline">1300 PLAN STACK</a>
                      </div>
                   </div>

                   <div className="flex items-start">
                      <div className="bg-brand-100 p-3 rounded-lg text-brand-600 mr-4">
                        <MapPin size={24} />
                      </div>
                      <div>
                        <h4 className="font-bold text-gray-900">Head Office</h4>
                        <p className="text-sm text-gray-500 mb-1">Melbourne VIC, Australia</p>
                        <p className="text-gray-900 font-medium">Level 10, 459 Collins Street</p>
                      </div>
                   </div>
                </div>
             </div>

             <div className="bg-brand-900 text-white p-8 rounded-2xl shadow-lg">
                <h4 className="text-xl font-bold mb-4 flex items-center">
                   <Clock size={20} className="mr-2" /> Support Hours
                </h4>
                <p className="text-brand-100 text-sm mb-4">Our national support team is available during standard business hours across all Australian states.</p>
                <div className="space-y-2 text-sm">
                   <div className="flex justify-between text-brand-200"><span>Mon-Fri:</span> <span className="text-white font-bold">9:00am - 5:30pm</span></div>
                   <div className="flex justify-between text-brand-200"><span>Sat-Sun:</span> <span className="text-white font-bold">Email Support Only</span></div>
                </div>
             </div>
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-2">
             <div className="bg-white p-10 rounded-2xl shadow-xl border border-gray-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                   <MessageSquare className="mr-3 text-brand-600" /> Send a Message
                </h3>
                <form className="space-y-6">
                   <div className="grid sm:grid-cols-2 gap-6">
                      <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                         <input type="text" className="w-full border-gray-300 rounded-lg focus:ring-brand-500 focus:border-brand-500" placeholder="John" />
                      </div>
                      <div>
                         <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                         <input type="text" className="w-full border-gray-300 rounded-lg focus:ring-brand-500 focus:border-brand-500" placeholder="Doe" />
                      </div>
                   </div>
                   <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                      <input type="email" className="w-full border-gray-300 rounded-lg focus:ring-brand-500 focus:border-brand-500" placeholder="john@example.com" />
                   </div>
                   <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                      <select className="w-full border-gray-300 rounded-lg focus:ring-brand-500 focus:border-brand-500">
                         <option>General Enquiry</option>
                         <option>Business Listing / Partnership</option>
                         <option>Advertising Opportunities</option>
                         <option>Report an Issue</option>
                         <option>Other</option>
                      </select>
                   </div>
                   <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                      <textarea className="w-full border-gray-300 rounded-lg focus:ring-brand-500 focus:border-brand-500" rows={6} placeholder="How can we help you?"></textarea>
                   </div>
                   <div className="pt-2">
                      <button type="button" className="bg-brand-600 hover:bg-brand-700 text-white font-bold py-4 px-10 rounded-xl transition shadow-md">
                         Send Message
                      </button>
                   </div>
                </form>
             </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;